export enum ContextKeys {
  APPLICATION = "$application",
  FORM = "$form",
  RESPONSE = "$response",
  THIS = "$this",
  EVENT = "$event",
  PIPELINE_STEP = "$pipelineStep",
  PAYLOAD = "$payload",
  RECORD = "$record",
}
